import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  MarketingTemplate,
  UpsertMarketingTemplatePayload
} from "../../marketing.types";

export const requestUpsertMarketingTemplate = async (
  payload: UpsertMarketingTemplatePayload
): Promise<MarketingTemplate> => {
  return await instance.post(ApiRoutesMarketing.Templates, payload);
};
